import React, { useState, useEffect } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import { Col, Container, Row, Form, Table } from "react-bootstrap";
import {
  Breadcrumbs,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Drawer,
} from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { NavLink, useHistory } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import {
  base_url,
  client_name,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { toast } from "react-toastify";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { ProductEnquiry } from "../../Components/Modals";
// import { useParams } from "react-router-dom";
import ShopStyle from '../../Assets/css/RingDiamondShop.module.css'
const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const Watches = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );
  let { brand } = useParams();
  const [filterdata, setFilterdata] = useState([]);
  const [filterSortByList, setfilterSortByList] = useState([]);
  const [sortSelected, setsortSelected] = useState("");
  const [productCount, setProductCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [view, setView] = useState(1);
  const [page, setPage] = useState(1);
  const [watchList, setWatchList] = useState([]);
  const [demofilterlist, setDemofilterlist] = useState([]);
  const [left, setLeft] = useState(false);
  const [addedfilter, setAddedfilter] = useState(
    JSON.parse(sessionStorage.getItem("bw-watchfilter"))
      ? JSON.parse(sessionStorage.getItem("bw-watchfilter"))
      : []
  );
  const [checkFilter, setcheckFilter] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const [filtercount, setFiltercount] = useState(0);
  const [filter, setFilter] = useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [expanded, setExpanded] = useState("panel0");
  const [inquiry, setInquiry] = useState(false);
  const [inquiry_id, setInquiry_id] = useState("");

  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });

  useEffect(() => {
    watchlistdata();
  }, [page]);

  useEffect(() => {
    if (addedfilter?.length || sortSelected !== "") {
      watchlistdata();
      setPage(1);
      var count = 0;
      addedfilter?.map((val) => {
        if (val?.name.length) {
          count++;
        }
      });
      count > 0 ? setFiltercount(1) : setFiltercount(0);
    }
  }, [addedfilter, sortSelected]);

  useEffect(() => {
    filterApi();
  }, []);

  const watchlistdata = () => {
    setLoader(true);
    setWatchList([]);
    var data = {
      currency_code: currencycode,
      start: (page - 1) * 18,
      length: 18,
      sort_by: sortSelected,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      token: isLogin ? user.token : "",
      filterdata: addedfilter,
    };
    axios
      .post(base_url + "/watch/watch_list", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setTotalCount(res.data.data?.count);
          setWatchList(res.data.data?.result);
          var count = (res.data.data?.count / 18).toFixed();
          if (count * 18 >= res.data.data?.count) {
            setPageCount(count);
          } else {
            setPageCount(Number(count) + 1);
          }
          setLoader(false);
        } else {
          setPageCount(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: product_id?.stock_no,
      type: "watch",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = watchList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setWatchList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const filterApi = () => {
    const data = {
      currency_code: currencycode,
    };
    axios
      .post(base_url + "/watch/watch_filter", data, {
        headers: postHeader,
      })
      .then(async (res) => {
        if (res.data.status === 1) {
          setFilterdata(res?.data?.data);
          setfilterSortByList(res?.data?.sort_by);
          var temp = [];
          res?.data?.data?.forEach((e) => {
            e.value.map((val) => {
              val?.title !== "Brand"
                ? temp.push({
                  title: val?.title,
                  filter: [],
                  name: [],
                })
                : val?.title === "Brand" && brand
                  ? temp.push({
                    title: "Brand",
                    filter: [brand?.replaceAll("-", " ")?.toUpperCase()],
                    name: [brand?.replaceAll("-", " ")?.toUpperCase()],
                  })
                  : temp.push({
                    title: val?.title,
                    filter: [],
                    name: [],
                  });
            });
          });

          setDemofilterlist(temp);
          sessionStorage.setItem("bw-watchfilter", JSON.stringify(temp));
          setAddedfilter(
            addedfilter.length > 0
              ? JSON.parse(sessionStorage.getItem("bw-watchfilter"))
              : temp
          );

          await addedfilter.forEach((e, i) => {
            if (e.filter.length > 0) {
              setFiltercount(1);
            } else {
              //setFiltercount(0);
              //sessionStorage.setItem("bw-watchfilter",JSON.stringify(temp))
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlecheckChange = (e, title, value, name) => {
    var changedata = [...addedfilter];
    if (e.target.checked) {
      changedata?.forEach((val) => {
        if (val.title == title) {
          val.filter.push(value);
          val.name.push(name);
        }
      });
      setAddedfilter(changedata);
      sessionStorage.setItem("bw-watchfilter", JSON.stringify(changedata));
    } else {
      changedata.forEach((item) => {
        if (item.title === title) {
          let index = item.filter.indexOf(value);
          item.filter.splice(index, 1);
          item.name.splice(index, 1);
        }
      });
      setAddedfilter(changedata);
      sessionStorage.setItem("bw-watchfilter", JSON.stringify(changedata));
    }
    if (changedata.length > 0) {
      setFiltercount(1);
    }
  };

  const checkboxcheck = (title, value, i) => {
    var data = false;
    if (addedfilter !== null) {
      if (addedfilter.some((ele) => ele.filter.includes(`${value}`))) {
        data = true;
      }
    }
    return data;
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(panel);
  };

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  const handleShowInquiry = (id) => {
    setInquiry_id(id);
    setInquiry(true);
  };
  const handleCloseInquiry = () => {
    setInquiry_id("");
    setInquiry(false);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>

      <div className={ShopStyle.BannerTop}>
        <Container>
          {/* <h3 className={ShopStyle.subTitle}>Design Your Own</h3> */}
          <h2 className={ShopStyle.Title}>Find Watches Easily</h2>
          <p>
            The collection of watches with uniqueness and mesmerizing
            designs. Each piece is crafted with precision by our experts.
          </p>
          <ul className={ShopStyle.BreadcrumbS}>
            <li><a href='/'>Home</a></li>
            <li>/</li>
            <li>Watches</li>
          </ul>
        </Container>
      </div>

      <div className="rcs_ringsetting_section ">
        <Container fluid>
          <div className={ShopStyle.MainBoxRingDiamondShop + ' ' + ShopStyle.ProductListPage }>
            {/* Left box Filters */}
            {screenWidth > 767 && (
              <div className={ShopStyle.LeftContainer}>
                <div className="remPadLg px-5">
                  <div className="sidebarWrapper">
                    <div className="rcs_filter_tags">
                      {!filtercount ? (
                        ""
                      ) : (
                        <div className="rcs_filter_list">
                          <h5>
                            <span>Filtering by:</span>
                            <button
                              onClick={() => {
                                setAddedfilter(demofilterlist);
                                sessionStorage.setItem(
                                  "bw-watchfilter",
                                  JSON.stringify(demofilterlist)
                                );
                                filterApi();
                              }}
                              className="clear-all-filters noBtn"
                            >
                              CLEAR ALL
                            </button>
                          </h5>
                          <div className="filter_tgs_list">
                            {addedfilter?.map((val) =>
                              val.name?.map((items, index) => (
                                <>
                                  <Button className="gs_filter_btn">
                                    {items}
                                    <CloseIcon
                                      onClick={(e) =>
                                        handlecheckChange(
                                          e,
                                          val.title,
                                          val.filter[index],
                                          items
                                        )
                                      }
                                      className="gs_tags_svg"
                                    />
                                  </Button>
                                </>
                              ))
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {filterdata?.map((val, index) => (
                      <Accordion
                        expanded={expanded === "panel" + index ? true : false}
                        onChange={handleChange("panel" + index)}
                        className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                      >
                        <AccordionSummary
                          expandIcon={
                            expanded === "panel" + index ? (
                              <span className="fww">-</span>
                            ) : (
                              <span className="fww">+</span>
                            )
                          }
                          aria-controls="panel2a-content"
                          id={`panel2a-header${index}`}
                          className="w-100"
                        >
                          <Typography>
                            <div className="fs16 fw600 pl-1 WatchListFilterTitle">{val?.title}</div>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="pb-0 pt-0">
                          <div className="rcs_price_filter">
                            {val?.value?.map((item, index1) => (
                              <>
                                {val?.title !== item?.title && (
                                  <h6>
                                    <span>{item?.title}</span>
                                  </h6>
                                )}
                                <>
                                  {item?.value?.map((newVal, index2) => (
                                    <FormGroup>
                                      <FormControlLabel className="WatchListFilterinnertitle"
                                        control={
                                          <Checkbox
                                            checked={checkboxcheck(
                                              item?.title,
                                              newVal?.value,
                                              index
                                            )}
                                            onChange={(e) =>
                                              handlecheckChange(
                                                e,
                                                item?.title,
                                                newVal?.name,
                                                newVal?.value
                                              )
                                            }
                                          />
                                        }
                                        label={newVal.name}
                                      />
                                    </FormGroup>
                                  ))}
                                </>
                              </>
                            ))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="rcs_mobile_filter_section">
              <Drawer anchor="left" open={left} onClose={() => setLeft(false)}>
                <div
                  className="drawerX"
                  role="presentation"
                  onKeyDown={() => setLeft(false)}
                >
                  <div className="rcs_filter_tags ">
                    {!filtercount ? (
                      ""
                    ) : (
                      <div className="rcs_filter_list">
                        <h5>
                          <span>Filtering by:</span>
                          <button
                            onClick={() => {
                              setAddedfilter(demofilterlist);
                              sessionStorage.setItem(
                                "bw-watchfilter",
                                JSON.stringify(demofilterlist)
                              );
                              filterApi();
                            }}
                            className="clear-all-filters noBtn"
                          >
                            CLEAR ALL
                          </button>
                        </h5>
                        <div className="filter_tgs_list">
                          {addedfilter?.map((val) =>
                            val.name?.map((items, index) => (
                              <>
                                <Button className="gs_filter_btn">
                                  {items}
                                  <CloseIcon
                                    onClick={(e) =>
                                      handlecheckChange(
                                        e,
                                        val.title,
                                        val.filter[index],
                                        items
                                      )
                                    }
                                    className="gs_tags_svg"
                                  />
                                </Button>
                              </>
                            ))
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {filterdata?.map((val, index) => (
                    <Accordion
                      expanded={expanded === "panel" + index ? true : false}
                      onChange={handleChange("panel" + index)}
                      className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                    >
                      <AccordionSummary
                        expandIcon={"+"}
                        aria-controls="panel2a-content"
                        id={`panel2a-header${index}`}
                        className="w-100"
                      >
                        <Typography>
                          <div className="fs16 fw600 pl-1 WatchListFilterTitle">{val?.title}</div>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="pb-0 pt-0">
                        <div className="rcs_price_filter">
                          {val?.value?.map((item, index1) => (
                            <>
                              <h6>
                                <span>{item?.title}</span>
                              </h6>
                              <>
                                {item?.value?.map((newVal, index2) => (
                                  <FormGroup>
                                    <FormControlLabel className="WatchListFilterinnertitle"
                                      control={
                                        <Checkbox
                                          checked={checkboxcheck(
                                            item?.title,
                                            newVal?.value,
                                            index
                                          )}
                                          onChange={(e) => {
                                            handlecheckChange(
                                              e,
                                              item?.title,
                                              newVal?.name,
                                              newVal?.value
                                            );
                                          }}
                                        // onChange={(e) => {
                                        //   item?.title === "Brand"
                                        //     ? history.push(
                                        //         `/watches/${newVal?.value}`
                                        //       )
                                        //     : handlecheckChange(
                                        //         e,
                                        //         item?.title,
                                        //         newVal?.name,
                                        //         newVal?.value
                                        //       );
                                        // }}
                                        />
                                      }
                                      label={newVal.name}
                                    />
                                  </FormGroup>
                                ))}
                              </>
                            </>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </Drawer>
            </div>


            {/* Right box products */}
            <div className={ShopStyle.RightContainer}>
              <div
                className="rcs_diamond_table pl-2 pr-2 mb-md-3 mb-0"
              >
                <div className={"rcs_view mobPb15 " + ShopStyle.TopviewProductsBox}>


                  {screenWidth < 767 && (
                    <button className="mobileFilterBtn" onClick={() => setLeft(true)}>
                      Filter
                    </button>
                  )}
                  {screenWidth > 767 && (
                    <div className={ShopStyle.TopviewProductsBoxLeft}>
                      {loader ? (
                        <>
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className=""
                            width={150}
                            height={20}
                          />
                        </>
                      ) : (
                        <span className="">
                          {totalCount} Product(s) Found
                        </span>
                      )}
                    </div>
                  )}


                  <div className={ShopStyle.TopviewProductsBoxRight}>
                    <div className="rcs_sorting">
                      <div className={"rcs_sort_filter  " + ShopStyle.TopviewProductsshortBy}>
                        <label
                        // className="mb-0 mr-1 fs14"
                        // htmlFor="sorting"
                        // style={{ minWidth: "55px" }}
                        >
                          <span className={ShopStyle.TopviewProductsshortByTitle}>Sort By</span>

                        </label>
                        <Form.Select
                          // style={{ minWidth: "130px" }}
                          name=""
                          id="sorting"
                          // className="form-control w-auto"
                          onChange={(e) => setsortSelected(e.target.value)}
                        >
                          {filterSortByList.length > 0 &&
                            filterSortByList?.map((e, i) => (
                              <option key={i} value={e.value}>
                                {e.name}
                              </option>
                            ))}
                        </Form.Select>
                      </div>
                    </div>
                  </div>

                </div>
                {screenWidth < 767 && (
                  <div className={ShopStyle.TopviewProductsBox + ' pt-0'}>
                    <div className={ShopStyle.TopviewProductsBoxLeft}>
                      {loader ? (
                        <>
                          <Skeleton
                            variant="text"
                            animation="wave"
                            className=""
                            width={150}
                            height={20}
                          />
                        </>
                      ) : (
                        <span>  {totalCount} Product(s) Found </span>
                      )}
                    </div>
                  </div>
                )}
                {view === 2 ? (
                  ""
                ) : (
                  <>
                    <Row>
                      {loader ? (
                        <>
                          {[...Array(15)].map((val) => (
                            <>
                              <Col lg={4} md={4} xs={12}>
                                <Skeleton
                                  variant="text"
                                  style={{
                                    transform: "unset",
                                    margin: "0 auto",
                                    marginBottom: "15px",
                                  }}
                                  animation="wave"
                                  height={300}
                                />
                              </Col>
                            </>
                          ))}
                        </>
                      ) : (
                        watchList.map((row, index) => (
                          <Col lg={4} md={4} xs={6} className="parentListWatch">
                            <div className="rcs_diamonds_grid_content watchList rcs_product_item">
                              {/* <span className="rcs_diamonds_grid_info" >
                                        <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                              {/* <span
                              className="rcs_diamonds_grid_wishlist"
                              style={{ cursor: "pointer" }}
                            >
                              {row.is_wishlist == "0" ? (
                                <FavoriteBorderIcon
                                  onClick={() => addtowishlist(row, index)}
                                />
                              ) : (
                                <FavoriteIcon
                                  onClick={() => addtowishlist(row, index)}
                                  className="animate__animated animate__heartBeat"
                                />
                              )}
                            </span> */}
                              <div className="d-flex flex-column justify-content-between h-100">
                                <NavLink
                                  className="imgWrapperWatch"
                                  to={"/watch-details/" + row.stock_no}
                                >
                                  <img
                                    src={row.imagelink}
                                    alt="diamonds"
                                    className
                                  />
                                </NavLink>

                                <div className={ShopStyle.HoverBoxIcons + ' ringSettingHoverBox'}>
                                  <div className={ShopStyle.HoverBoxWishlist + ' ringSettingHoverBoxWishlist'}>
                                    {row.is_wishlist == "0" ? <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist11} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g filter="url(#filter0_d_1_256)">
                                        <circle cx="43" cy="43" r="23" fill="white" />
                                      </g>
                                      <path d="M53.1494 34.8506C52.5629 34.2639 51.8667 33.7985 51.1003 33.481C50.334 33.1634 49.5126 33 48.6831 33C47.8535 33 47.0321 33.1634 46.2658 33.481C45.4994 33.7985 44.8032 34.2639 44.2167 34.8506L42.9997 36.0677L41.7826 34.8506C40.5981 33.6661 38.9915 33.0006 37.3163 33.0006C35.6411 33.0006 34.0346 33.6661 32.85 34.8506C31.6655 36.0352 31 37.6417 31 39.3169C31 40.9921 31.6655 42.5987 32.85 43.7833L34.0671 45.0003L42.9997 53.9329L51.9323 45.0003L53.1494 43.7833C53.7361 43.1968 54.2015 42.5006 54.519 41.7342C54.8366 40.9679 55 40.1465 55 39.3169C55 38.4874 54.8366 37.666 54.519 36.8997C54.2015 36.1333 53.7361 35.4371 53.1494 34.8506V34.8506Z" stroke="#14344A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                      <defs>
                                        <filter id="filter0_d_1_256" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                          <feOffset />
                                          <feGaussianBlur stdDeviation="10" />
                                          <feComposite in2="hardAlpha" operator="out" />
                                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_256" />
                                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_256" result="shape" />
                                        </filter>
                                      </defs>
                                    </svg> :
                                      <svg onClick={() => addtowishlist(row, index)} className={ShopStyle.HoverBoxWishlist21} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g filter="url(#filter0_d_1_259)">
                                          <circle cx="43" cy="43" r="23" fill="#607980" />
                                        </g>
                                        <path d="M37.2813 32.0106C35.347 31.9071 33.4069 32.5587 31.9789 33.9959C29.1212 36.878 29.4201 41.7147 32.4778 44.796L33.4545 45.7791L42.3305 54.7204C42.5089 54.8995 42.7506 55 43.0026 55C43.2545 55 43.4962 54.8995 43.6747 54.7204L52.5469 45.7791L53.5236 44.796C56.5812 41.7147 56.8782 36.878 54.0186 33.9978C51.1608 31.1176 46.3649 31.4242 43.3091 34.5037L43.0007 34.8141L42.6922 34.5037C41.1634 32.9611 39.2176 32.1141 37.2813 32.0106Z" fill="white" />
                                        <defs>
                                          <filter id="filter0_d_1_259" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                            <feOffset />
                                            <feGaussianBlur stdDeviation="10" />
                                            <feComposite in2="hardAlpha" operator="out" />
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_259" />
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_259" result="shape" />
                                          </filter>
                                        </defs>
                                      </svg>
                                    }
                                  </div>
                                  {/* <div className={ShopStyle.HoverBoxWishlist + ' ringSettingHoverBoxWishlist'}>
                                        <svg onClick={() => quickopen(val)} className={ShopStyle.HoverBoxWishlist1} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g filter="url(#filter0_d_1_251)">
                                            <circle cx="43" cy="43" r="23" fill="white" />
                                          </g>
                                          <path d="M54.9088 42.582C52.9428 38.311 48.4998 34 42.9998 34C37.4998 34 33.0568 38.311 31.0908 42.582C31.0309 42.7132 31 42.8558 31 43C31 43.1442 31.0309 43.2868 31.0908 43.418C33.0568 47.689 37.4998 52 42.9998 52C48.4998 52 52.9428 47.689 54.9088 43.418C54.9686 43.2868 54.9995 43.1442 54.9995 43C54.9995 42.8558 54.9686 42.7132 54.9088 42.582V42.582ZM42.9998 50C38.5888 50 34.8538 46.448 33.1098 43C34.8538 39.552 38.5888 36 42.9998 36C47.4108 36 51.1458 39.552 52.8898 43C51.1458 46.448 47.4108 50 42.9998 50Z" fill="#607980" />
                                          <path d="M42.9998 38C42.0109 38 41.0442 38.2932 40.2219 38.8427C39.3997 39.3921 38.7588 40.173 38.3804 41.0866C38.0019 42.0002 37.9029 43.0055 38.0958 43.9755C38.2888 44.9454 38.765 45.8363 39.4642 46.5355C40.1635 47.2348 41.0544 47.711 42.0243 47.9039C42.9942 48.0969 43.9995 47.9978 44.9132 47.6194C45.8268 47.241 46.6077 46.6001 47.1571 45.7779C47.7065 44.9556 47.9998 43.9889 47.9998 43C47.9982 41.6744 47.4709 40.4036 46.5335 39.4662C45.5962 38.5289 44.3254 38.0016 42.9998 38V38ZM42.9998 46C42.4064 46 41.8264 45.8241 41.333 45.4944C40.8397 45.1648 40.4552 44.6962 40.2281 44.1481C40.0011 43.5999 39.9416 42.9967 40.0574 42.4147C40.1732 41.8328 40.4589 41.2982 40.8784 40.8787C41.298 40.4591 41.8325 40.1734 42.4145 40.0576C42.9964 39.9419 43.5996 40.0013 44.1478 40.2284C44.696 40.4554 45.1645 40.8399 45.4942 41.3333C45.8238 41.8266 45.9998 42.4067 45.9998 43C45.9998 43.7956 45.6837 44.5587 45.1211 45.1213C44.5585 45.6839 43.7954 46 42.9998 46Z" fill="#607980" />
                                          <defs>
                                            <filter id="filter0_d_1_251" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite in2="hardAlpha" operator="out" />
                                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_251" />
                                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_251" result="shape" />
                                            </filter>
                                          </defs>
                                        </svg>
                                        <svg onClick={() => quickopen(val)} className={ShopStyle.HoverBoxWishlist2} width="86" height="86" viewBox="0 0 86 86" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <g filter="url(#filter0_d_1_262)">
                                            <circle cx="43" cy="43" r="23" fill="#607980" />
                                          </g>
                                          <path d="M54.91 42.58C52.94 38.31 48.5 34 43 34C37.5 34 33.06 38.31 31.09 42.58C31.0307 42.7121 31 42.8552 31 43C31 43.1448 31.0307 43.2879 31.09 43.42C33.06 47.69 37.5 52 43 52C48.5 52 52.94 47.69 54.91 43.42C54.9693 43.2879 55 43.1448 55 43C55 42.8552 54.9693 42.7121 54.91 42.58V42.58ZM43 48C42.0111 48 41.0444 47.7068 40.2221 47.1573C39.3999 46.6079 38.759 45.827 38.3806 44.9134C38.0022 43.9998 37.9031 42.9945 38.0961 42.0245C38.289 41.0546 38.7652 40.1637 39.4645 39.4645C40.1637 38.7652 41.0546 38.289 42.0245 38.0961C42.9945 37.9031 43.9998 38.0022 44.9134 38.3806C45.827 38.759 46.6079 39.3999 47.1573 40.2221C47.7068 41.0444 48 42.0111 48 43C47.9984 44.3256 47.4711 45.5964 46.5338 46.5338C45.5964 47.4711 44.3256 47.9984 43 48V48Z" fill="white" />
                                          <path d="M43 46C44.6569 46 46 44.6569 46 43C46 41.3431 44.6569 40 43 40C41.3431 40 40 41.3431 40 43C40 44.6569 41.3431 46 43 46Z" fill="white" />
                                          <defs>
                                            <filter id="filter0_d_1_262" x="0" y="0" width="86" height="86" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                              <feOffset />
                                              <feGaussianBlur stdDeviation="10" />
                                              <feComposite in2="hardAlpha" operator="out" />
                                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_262" />
                                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_262" result="shape" />
                                            </filter>
                                          </defs>
                                        </svg>
                                      </div> */}
                                </div>

                                <div className="rcs_product_info">
                                  {/* <NavLink  to={"/watch-details/" + row.stock_no}> */}
                                  <h3 onClick={() => history.push("/watch-details/" + row.stock_no)} className="text-center">{row.name}</h3>
                                  {/* </NavLink> */}
                                  <p className="rcs_emailprice rcs_diamonds_price_s">
                                    {row.is_price == 1 ? (
                                      <>
                                        {currency}
                                        {row.sale_price}
                                      </>
                                    ) : (
                                      <span
                                        style={{
                                          borderBottom: "1px solid rgb(0, 0, 0)",
                                          padding: "7px 0px",
                                          textTransform: "uppercase",
                                          fontSize: "11px",
                                          textAlign: "center",
                                        }}
                                        variant="contained"
                                        // className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                                        onClick={() =>
                                          handleShowInquiry(row?.stock_no)
                                        }
                                      >
                                        Inquiry
                                      </span>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))
                      )}
                    </Row>
                    <Row className="mt-5 mb-3">
                      <Col xs={12} className="pr-0 m-auto">
                        <div
                          className="rcs_sorting_pagi"
                          onClick={() => window.scrollTo(0, 0)}
                        >
                          <Stack
                            spacing={2}
                            className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                          >
                            <Pagination
                              count={pageCount}
                              page={page}
                              onChange={handlePageChange}
                              shape="rounded"
                            />
                          </Stack>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>

          </div>
        </Container>
        <Container className="rcs_shap-wizard_container">
          {/* <Row>
            <Col className="rcs_breadcrumb mb-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  Home
                </NavLink>
                <Typography color="text.primary">Watches</Typography>
              </Breadcrumbs>
            </Col>
          </Row> */}
          {/* <Row className="w-100 d-block m-auto">
            <Col xs={12} className="p-0">
              <div className="rcs_diamond_content1 mb-3">
                <h1 className="text-left text-capitalize fs30">
                  Find Watches Easily
                </h1>
                <p>
                  The collection of watches with uniqueness and mesmerizing
                  designs. Each piece is crafted with precision by our experts{" "}
                </p>
              </div>
            </Col>
          </Row> */}




          {/*Inquiry Modal*/}
          {inquiry && inquiry_id ? (
            <ProductEnquiry
              productid={inquiry_id}
              handleCloseInquiry={handleCloseInquiry}
            />
          ) : (
            ""
          )}
          {/*Inquiry Modal*/}
        </Container>
      </div>
    </>
  );
};

export default Watches;
